import { render, staticRenderFns } from "./bookingLearnMore.vue?vue&type=template&id=1a197d6d"
import script from "./bookingLearnMore.vue?vue&type=script&lang=js"
export * from "./bookingLearnMore.vue?vue&type=script&lang=js"
import style0 from "./bookingLearnMore.vue?vue&type=style&index=0&id=1a197d6d&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a197d6d')) {
      api.createRecord('1a197d6d', component.options)
    } else {
      api.reload('1a197d6d', component.options)
    }
    module.hot.accept("./bookingLearnMore.vue?vue&type=template&id=1a197d6d", function () {
      api.rerender('1a197d6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/bookingLearnMore.vue"
export default component.exports